export const NewEditAdjustmentEnum = {
  NEW: '0',
  VIEW: '1',
};

export const StatusAndTypeEnum = {
  Type: 'O',
  Status: 'O',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/AdjustmentListEnum.js